module.exports = __webpack_public_path__ + "media/images/map/trip-835b9e5d254e392da2e2107da2d9d031.svg";